<script lang="ts">
  import type { Player as PlayerProps } from '../shared/codecs/Player'
  import Player from './Component.svelte'
  export let players: PlayerProps[] | undefined
</script>

<ul>
  {#if players !== undefined}
    {#each players as player (player.uid)}
      <Player {...player} />
    {/each}
  {/if}
</ul>

<style>
  ul {
    box-sizing: border-box;
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    align-items: center;
    margin: 1rem 0;
    padding: 0;
  }
</style>
